import Component from './instagram_campaign_prize.vue'
export default Component
